<template>
  <main>
    <section class="fk-contents">
      <h2 class="title-lv2 mb20">{{$t('Payment.MFCHeading')}}</h2>

      <div class="mod-form-block">
        <span class="label">{{$t('Payment.MFCNumber')}}{{$t('General.Digits16')}}</span>
        <div class="input-my-first-card-wrap">
          <!-- number-segment1 -->
          <!-- 商用環境用 先頭4桁を固定値とする。v-modelが衝突するためバインディングしない -->
          <input v-if="config.VUE_APP_MODE==='production'" type="number" name="" id="" class="input-my-first-card" :value="config.VUE_APP_MFCARD_SEGMENT1" readonly>
          <!-- 検証環境用 -->
          <input v-if="config.VUE_APP_MODE!=='production'" type="text" inputmode="numeric" name="" id="number-segment1" class="input-my-first-card" placeholder="0000" maxlength="4" tabindex="2" v-model="card.number.segment1" @keydown="inputControl($event)">
          <!-- number-segment1 -->
          <span class="hyphen">-</span>
          <input type="text" inputmode="numeric" name="" id="number-segment2" class="input-my-first-card" placeholder="0000" maxlength="4" tabindex="2" v-model="card.number.segment2" @keydown="inputControl($event)">
          <span class="hyphen">-</span>
          <input type="text" inputmode="numeric" name="" id="number-segment3" class="input-my-first-card" placeholder="0000" maxlength="4" tabindex="3" v-model="card.number.segment3" @keydown="inputControl($event)">
          <span class="hyphen">-</span>
          <input type="text" inputmode="numeric" name="" id="number-segment4" class="input-my-first-card" placeholder="0000" maxlength="4" tabindex="4" v-model="card.number.segment4" @keydown="inputControl($event)">
        </div>
        <span class="validation-error" v-if="errors.number !== null">{{errors.number}}</span>
      </div>
      <div class="mod-form-block">
        <span class="label">{{$t('Payment.Pin')}}{{$t('General.Digits6')}}</span>
        <input type="password" name="" id="pin" class="input-my-first-card" tabindex="5" v-model="card.pin">
        <span class="validation-error" v-if="errors.pin !== null">{{errors.pin}}</span>
      </div>

      <p class="mod-form-btn"><a href="#" class="btn-base btn-sub" @click.prevent="confirmationBalance">{{$t('Payment.ConfirmationBalance')}}</a></p>

      <div class="mod-normal-box mtb20" v-if="firstConfirmation">
        <dl class="mod-horizontal-definition">
          <dt>{{$t('Payment.Balance')}}</dt>
          <dd><strong>￥{{balanceTotal}}</strong></dd>
        </dl>
        <dl class="mod-horizontal-definition">
          <dt>{{$t('Payment.Point')}}</dt>
          <dd><strong>{{balancePoint}}pt</strong></dd>
        </dl>
      </div>

      <form name="onlinecharge" :action="this.getOnlineChargeUrl()" method="post" @submit='postOnlineCharge' v-if="firstConfirmation">
        <p class="mod-form-btn"><input type="submit" :value="$t('Payment.OnlineCharge')" :disabled="getDisabledButton===true" class="btn-base btn-sub pointer"></p>
        <input type="hidden" name="bkurl" :value="this.getDomainUrl() + '/mo-site/payment/mfcard/charge/complete'">
      </form>

      <div class="mod-normal-box mtb20" v-if="firstConfirmation">
        <dl class="mod-horizontal-definition">
          <dt>{{$t('General.Total')}}</dt>
          <dd><strong>￥{{displayThousandsSeparator(getOrderDetail.totalPrice)}}</strong>{{getOrderDetail.taxType}}</dd>
        </dl>
      </div>

      <h2 class="title-lv2 no-border mb10" v-if="firstConfirmation && !isUseAccountingCoupon">{{$t('Payment.UsePoint')}}</h2>
      <div class="mod-form-block" v-if="firstConfirmation">
        <span class="label">{{$t('Payment.InputPoint')}}</span>
        <div class="has-connect">
          <input type="number" name="" id="point" v-model="card.point" :disabled="canNotUsePoint">
          <span class="connect">pt</span>
        </div>
        <span class="validation-error" v-if="errors.point !== null">{{errors.point}}</span>
        <span class="validation-error" v-if="canNotUsePoint">{{$t('InvalidMsg.ERR_074')}}</span>
      </div>

      <p class="mod-form-btn" v-if="firstConfirmation"><a href="#" class="btn-base btn-main" @click.prevent="fix">{{$t('Payment.Pay')}}</a></p>
      <p class="mod-form-btn btn-back"><input type="submit" :value="$t('General.Return')" class="btn-base btn-negative btn-quit" @click.prevent="execBack()"></p>
    </section>
  </main>
</template>

<script>
import CommonMixin from '@/mixins/CommonMixin'
import ValidationMixin from '@/mixins/ValidationMixin'
import DisplayErrorMixin from '@/mixins/DisplayErrorMixin'
import {get} from 'lodash'
export default {
  name: 'FKMOInputMFCard',
  mixins: [ CommonMixin, ValidationMixin, DisplayErrorMixin ],
  data () {
    return {
      balanceTotal: 0,
      balancePoint: 0,
      card: {
        number: {
          segment1: null, // NOTE MFカードのsegment1(先頭4桁)は商用環境では固定値にする。
          segment2: null,
          segment3: null,
          segment4: null
        },
        pin: null,
        point: '0'
      },
      errors: {
        number: null,
        pin: null,
        point: null
      },
      firstConfirmation: false, // 初回残高照会フラグ。true=ページに遷移後、1回以上残高照会をしている
      config: {
        VUE_APP_MODE: null,
        VUE_APP_MFCARD_SEGMENT1: null
      },
      canNotUsePoint: false
    }
  },
  computed: {
    getOrderDetail () {
      return this.$store.getters.orderDetail
    },
    getDisabledButton () {
      return this.$store.getters.disabledButton
    },
    getCart () {
      return this.$store.getters.cart
    }
  },
  methods: {
    // 残高確認
    confirmationBalance: function (event) {
      let validate = this.validMyFirstCard(this.card, this.balancePoint)
      this.errors = validate.errors
      if (!validate.isValid) {
        return false
      }

      if (this.getDisabledButton) {
        return false
      }
      this.setDisabledButton(true)

      let that = this
      // POSTパラメータ
      const params = {
        'card_number': this.concatCardNumber(),
        'pin_code': this.card.pin
      }
      this.callApi('MFCardGetBalance',
        params
      )
      // this.axios.get('/static/stub/InputMFCard/input_mfcard_check_balance.json')
        .then(function (res) {
          if (res.data.result) {
            that.balanceTotal = res.data.value.balance_total
            that.balancePoint = res.data.value.balance_point
            that.firstConfirmationFlagUp()
          } else {
            that.errorFromApi(res.data.errorCode, res.data.error)
            that.firstConfirmationFlagDown()
          }
        })
        .catch((error) => {
          that.errorFromAxios(error)
          that.firstConfirmationFlagDown()
        })
        .finally(() => {
          that.setDisabledButton(false)
        })
    },
    // 確定
    fix: function (event) {
      // 注文確定時とカートの内容が異なる場合はエラー
      if (JSON.stringify(this.$store.getters.cart) !== this.CryptoJS.AES.decrypt(sessionStorage.getItem('confirmCart'), process.env.VUE_APP_CART_HASHKEY).toString(this.CryptoJS.enc.Utf8)) {
        window.commonAlert(this.$i18n.t('ErrorMsg.ERR_023'))
        return
      }
      let validate = this.validMyFirstCard(this.card, this.balancePoint, this.getOrderDetail.discountablePrice, this.canNotUsePoint)
      this.errors = validate.errors
      if (!validate.isValid) {
        return false
      }

      if (this.getDisabledButton) {
        return false
      }
      this.setDisabledButton(true)

      // pointの値をチェックする
      let usePoint
      if (this.card.point === null || this.card.point === undefined || this.card.point.length === 0) {
        usePoint = 0
      } else {
        usePoint = Number(this.card.point)
      }

      // バックエンドに渡す商品名のリストを生成する
      const displayItemInfo = []
      for (var i = 0; i < this.getOrderDetail.items.length; i++) {
        displayItemInfo.push({ 'item_name': this.getOrderDetail.items[i].name })
      }

      // POSTパラメータ
      let that = this
      const params = {
        'card_number': this.concatCardNumber(),
        'pin_code': this.card.pin,
        'use_point': usePoint,
        'order_id': this.getOrderDetail.orderId,
        'display_item_info': displayItemInfo
      }
      this.callApi('MFCardExecPayment',
        params
      )
        .then(function (res) {
          if (res.data.result) {
            let order = that.getOrderDetail
            order.ticketNumber = res.data.value.ticket_number
            that.$store.dispatch('setOrderDetail', order)

            // カート情報をクリアする
            that.clearCart(true)

            that.$router.push({ name: 'OrderProcessing' })
          } else {
            that.errorFromApi(res.data.errorCode, res.data.error)
          }
        })
        .catch((error) => {
          that.errorFromAxios(error)
        })
        .finally(() => {
          that.setDisabledButton(false)
        })
    },
    // 戻るボタン
    execBack: function () {
      this.$router.push({ name: 'PaymentMethod' })
    },
    // 券面情報取得
    getCardInfo: function () {
      let that = this

      // ログイン状態を確認
      if (this.getLoginInfo().isLogin) {
        this.setDisabledButton(true)
        // 登録済みカードを取得する
        this.callApi('MFCardGetInfo',
          {}
        )
        // this.axios.get('/static/stub/input_mfcard.json')
          .then((res) => {
            if (res.data.result) {
              that.disassemblyCardNumber(res.data.value.card_number)
              that.card.pin = res.data.value.pin_code
            } else {
              that.errorFromApi(res.data.errorCode, res.data.error)
            }
          })
          .catch((error) => {
            that.errorFromAxios(error)
          })
          .finally(() => {
            that.setDisabledButton(false)
          })
      }
    },
    // カード券面番号操作
    disassemblyCardNumber: function (number) {
      // カード券面番号をセグメント単位に分解する

      // null考慮
      if (number === null || number === undefined || number.length === 0) {
        return null
      }

      this.card.number = {
        segment1: number.substring(0, 4),
        segment2: number.substring(4, 8),
        segment3: number.substring(8, 12),
        segment4: number.substring(12)
      }
      // 商用環境では先頭4桁を固定値とする
      if (this.config.VUE_APP_MODE === 'production') {
        this.card.number.segment1 = this.config.VUE_APP_MFCARD_SEGMENT1
      }
    },
    concatCardNumber: function () {
      // 入力されている券面番号の各セグメントを文字列連結する
      let ret = ''

      // 商用環境では先頭4桁を固定値とする
      if (this.config.VUE_APP_MODE === 'production') {
        ret = this.config.VUE_APP_MFCARD_SEGMENT1
      } else {
        if (this.card.number.segment1 !== null && this.card.number.segment1.length > 0) {
          ret = ret.concat(this.card.number.segment1)
        }
      }

      if (this.card.number.segment2 !== null && this.card.number.segment2.length > 0) {
        ret = ret.concat(this.card.number.segment2)
      }
      if (this.card.number.segment3 !== null && this.card.number.segment3.length > 0) {
        ret = ret.concat(this.card.number.segment3)
      }
      if (this.card.number.segment4 !== null && this.card.number.segment4.length > 0) {
        ret = ret.concat(this.card.number.segment4)
      }
      return ret
    },
    inputControl: function (event) {
      // eE+.対応
      if (event.key.match(/^[eE+.]$/)) {
        event.preventDefault()
        return
      }
      // 数字を5文字以上の入力をさせない
      if (event.key.match(/[0-9]/)) {
        // 文字列選択をしていない場合は次の判定へ、文字列選択をしている時は入力を許可する
        if (window.getSelection().toString().length === 0) {
          // 5文字以上の入力不許可とする
          if (event.target.value.length >= 4) {
            event.preventDefault()
          }
        }
      }
    },
    // 初回残高照会フラグ操作
    firstConfirmationFlagUp: function () {
      sessionStorage.setItem('firstConfirmation', 'true')
      this.firstConfirmation = true
    },
    firstConfirmationFlagDown: function () {
      sessionStorage.removeItem('firstConfirmation')
      this.firstConfirmation = false
    },
    // ポイント利用可能フラグ操作
    checkCanUsePoint: function () {
      if (this.getOrderDetail.discountablePrice > 0) {
        this.canNotUsePoint = false
      } else {
        this.canNotUsePoint = true
      }
    },
    /** ↓↓↓オンラインチャージサイト遷移関連 ここから */
    // オンラインチャージサイト
    postOnlineCharge: function (event) {
      event.preventDefault()

      // カード情報をストレージに退避
      localStorage.setItem('mfcard', JSON.stringify(this.card))
      // 現在のsessionStorageを退避
      localStorage.setItem('lang', sessionStorage.getItem('lang'))
      localStorage.setItem('vuex', sessionStorage.getItem('vuex'))
      if (sessionStorage.getItem('login') !== null) {
        localStorage.setItem('login', sessionStorage.getItem('login'))
      }
      if (sessionStorage.getItem('firstConfirmation') !== null) {
        localStorage.setItem('firstConfirmation', sessionStorage.getItem('firstConfirmation'))
      }
      if (sessionStorage.getItem('email') !== null) {
        localStorage.setItem('email', sessionStorage.getItem('email'))
      }

      event.target.submit()
    },
    // カード番号の初期値
    initCardNumber: function () {
      if (this.config.VUE_APP_MODE === 'production') {
        this.card.number.segment1 = this.config.VUE_APP_MFCARD_SEGMENT1
      }
    },
    // ページ表示時の処理
    init: function () {
      try {
        let that = this
        if (this.$route.name === 'InputMFCardChargeComplete') {
          // title要素を書き換える
          document.title = this.getTitleElementString(this.getPageTitle('InputMFCard'))
          // ローカルストレージからカード情報を復元する
          this.card = JSON.parse(localStorage.getItem('mfcard'))
          if (this.card === null) {
            this.card = {
              number: {
                segment1: null,
                segment2: null,
                segment3: null,
                segment4: null
              },
              pin: null,
              point: '0'
            }
          }
          // 商用環境の場合はsegment1を固定値にする
          if (this.config.VUE_APP_MODE === 'production') {
            this.card.number.segment1 = this.config.VUE_APP_MFCARD_SEGMENT1
          }

          // sessionStorageを復元する
          sessionStorage.setItem('lang', localStorage.getItem('lang'))
          sessionStorage.setItem('vuex', localStorage.getItem('vuex'))
          if (localStorage.getItem('login') !== null) {
            sessionStorage.setItem('login', localStorage.getItem('login'))
            this.$store.dispatch('setUserAuthority', get(JSON.parse(localStorage.getItem('login')), 'authority', 1))
          }
          if (localStorage.getItem('firstConfirmation') !== null) {
            // localStorageに退避している場合、初回残高照会フラグを再設定する
            this.firstConfirmationFlagUp()
          }
          if (localStorage.getItem('email') !== null) {
            sessionStorage.setItem('email', localStorage.getItem('email'))
          }
          // 退避データを削除
          localStorage.removeItem('mfcard')
          localStorage.removeItem('lang')
          localStorage.removeItem('vuex')
          localStorage.removeItem('login')
          localStorage.removeItem('firstConfirmation')
          localStorage.removeItem('email')

          const params = {
            'card_number': this.concatCardNumber(),
            'pin_code': this.card.pin
          }
          this.callApi('MFCardGetBalance',
            params
          )
          // this.axios.get('/static/stub/InputMFCard/input_mfcard_check_balance.json')
            .then(function (res) {
              if (res.data.result) {
                that.balanceTotal = res.data.value.balance_total
                that.balancePoint = res.data.value.balance_point
              } else {
                that.errorFromApi(res.data.errorCode, res.data.error)
                that.firstConfirmationFlagDown()
              }
            })
            .catch((error) => {
              that.errorFromAxios(error)
              that.firstConfirmationFlagDown()
            })
            .finally(() => {
              that.setDisabledButton(false)
            })
        }
      } catch (ex) {
        this.errorFromApp(ex)
      }
    },
    restoreTextBox: function () {
      // NOTE
      // オンラインチャージサイトなどからhistory.backしてくると、input#number-segment1～4と
      // v-modelでバインディングしているthis.card.number.segment1～4に不整合が生じる。
      // この状態でPinを入力すると、カード番号が空欄になる。
      // （this.card.numberがnullで初期化されていて、この状態で描画が発生してしまうため）
      // そのため、不整合な状態に限定してカード番号の入力を維持する。

      // 商用環境では先頭4桁は固定値とする
      if (this.config.VUE_APP_MODE === 'production') {
        // 商用環境でなのでVUE_APP_MFCARD_SEGMENT1が持つ固定値をモデルにセットする
        this.card.number.segment1 = this.config.VUE_APP_MFCARD_SEGMENT1
      } else {
        if (document.getElementById('number-segment1').value.length > 0 && this.card.number.segment1 === null) {
          // 開発環境では入力値をモデルにセットする
          this.card.number.segment1 = document.getElementById('number-segment1').value
        }
      }

      if (document.getElementById('number-segment2').value.length > 0 && this.card.number.segment2 === null) {
        this.card.number.segment2 = document.getElementById('number-segment2').value
      }
      if (document.getElementById('number-segment3').value.length > 0 && this.card.number.segment3 === null) {
        this.card.number.segment3 = document.getElementById('number-segment3').value
      }
      if (document.getElementById('number-segment4').value.length > 0 && this.card.number.segment4 === null) {
        this.card.number.segment4 = document.getElementById('number-segment4').value
      }
    }
  },
  beforeMount () {
    // node.envから設定値を取得する
    // NOTE templateにprocess.envを埋め込むとDOM構築時にenvを呼べずにエラーになる
    this.config.VUE_APP_MODE = process.env.VUE_APP_MODE
    this.config.VUE_APP_MFCARD_SEGMENT1 = process.env.VUE_APP_MFCARD_SEGMENT1

    this.checkCanUsePoint()

    this.getCardInfo()
  },
  mounted () {
    this.card.point = 0
    this.initCardNumber()
    this.init()
  },
  beforeUpdate () {
    this.restoreScaleRate('default') // 拡大縮小のロックを開放
    this.restoreTextBox()
  },
  destroyed () {
    this.restoreScaleRate('reset') // scaleをリセット
  }
}
</script>

<style scoped>
.validation-error {
  color: #f00;
  display: block;
}
.pointer {
  cursor: pointer;
}
input[type="submit"] {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/InputMFCard.vue